export const AUD_DESKTOP_3875_NEWB_HEAD_PERETOK = 'aud_desktop_3875_newb_head_peretok';
export const BX_TUNE_AUTH = 'aud_web_aud3770_tune_authorization';
export const AUD_MOBILE_BANNER_TO_APP = 'aud_mobile_ADSC385_banner_to_app_listing_v2';

export const EXPERIMENTS = [BX_TUNE_AUTH, AUD_DESKTOP_3875_NEWB_HEAD_PERETOK, AUD_MOBILE_BANNER_TO_APP];
